export default {
    namespaced: true,
    state: {
        show_menu: false,
        transition: false,
        calculatorDialog: false,
        profileDialog: false
    },
    getters: {
        menuStatus: state => {
            return state.show_menu
        },
        transition: state => {
            return state.transition
        },
        calculatorDialog: state => {
            return state.calculatorDialog
        },
        profileDialog: state => {
            return state.profileDialog
        }
    },
    mutations: {
        SET_MENU: (state,payload) => {
            state.show_menu = payload
        },
        SET_TRANSITION: (state,payload) => {
            state.transition = payload
        },
        SET_CAL_DIALOG: (state, payload) => {
            state.calculatorDialog = payload
        },
        SET_PROFILE_DIALOG: (state, payload) => {
            state.profileDialog = payload
        }
    },
    actions: {
    }
}